export const formatDate = (date: string, destFormat: 'hyphen' | 'dots'): string =>
    date
        .split(destFormat === 'hyphen' ? '.' : '-')
        .reverse()
        .join(destFormat === 'hyphen' ? '-' : '.');
